/**
 * Only for QA environment, adds the Cloudflare Access headers to the request
 */
export function setCloudflareAccessQAHeaders(headers) {
  if (process.env.APP_ENV !== 'production' && process.env.CLOUDFLARE_ACCESS_CLIENT_ID && process.env.CLOUDFLARE_ACCESS_CLIENT_SECRET) {
    headers.append('CF-Access-Client-Id', process.env.CLOUDFLARE_ACCESS_CLIENT_ID);
    headers.append('CF-Access-Client-Secret', process.env.CLOUDFLARE_ACCESS_CLIENT_SECRET);
  }
}